'use client';

import dynamic from 'next/dynamic';

export const RealWorldUseCaseDemo = dynamic(
  () => import('./RealWorldUseCaseDemo')
);
export const WithAndWithoutFromDemo = dynamic(
  () => import('./WithAndWithoutFromDemo')
);
export const WithAndWithoutFromGraph = dynamic(
  () => import('./WithAndWithoutFromGraph')
);
export const ToTargetOpacityDemo = dynamic(
  () => import('./ToTargetOpacityDemo')
);
export const ToDynamicOpacityDemo = dynamic(
  () => import('./ToDynamicOpacityDemo')
);
export const ToDynamicGraph = dynamic(
  () => import('./ToDynamicGraph')
);

export const OscillationAmountDemo = dynamic(
  () => import('./OscillationAmountDemo')
);
